import { NSARouterMakerResult } from "namirasoft-account-react";
import { FieldEntities } from "../FieldEntities";
import { FieldLayout } from "../FieldLayout";
import { FieldProps } from "../FieldProps";

interface CategoryScopeViewPageProps extends NSARouterMakerResult, FieldProps { }

export default function CategoryScopeViewPage(props: CategoryScopeViewPageProps)
{
	return (
		<FieldLayout
			{...props}
			action={{
				description: "This section displays detailed information about a selected category scope."
			}}
			pages={{
				entity: FieldEntities.category_scope(props),
				view: {}
			}}
		>
			<> </>
		</FieldLayout>
	);
}